import {ServiceHistoryDTO} from "../../serviceHistoryDTO.interface";

export interface AdvertViewVehicleServiceHistoryDTO {
  serviceHistoryType?: number;
  serviceHistories: ServiceHistoryDTO[];
}
